import { render, staticRenderFns } from "./GPathAptitudeList.vue?vue&type=template&id=a4b0cfec"
import script from "./GPathAptitudeList.vue?vue&type=script&lang=js"
export * from "./GPathAptitudeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports